'use client'

import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import Check from '../../icons/Check'
import { cn } from '../../utils/cn'

const checkboxVariants = cva('', {
  variants: {
    // Keep selector prefixes literal: Tailwind's scanner cannot see composed class names.
    state: {
      radix:
        'bg-input data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=checked]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive-foreground aria-invalid:border-destructive peer size-5 shrink-0 transition-shadow outline-none focus-visible:ring-[2px] disabled:cursor-not-allowed disabled:opacity-50',
      native:
        'bg-input peer-checked:bg-primary peer-checked:text-primary-foreground peer-checked:border-primary peer-focus-visible:border-ring peer-focus-visible:ring-ring/50 size-5 shrink-0 transition-shadow outline-none peer-focus-visible:ring-[2px]'
    },
    variant: {
      square: 'rounded-[3px]',
      circle: 'rounded-full'
    }
  },
  defaultVariants: {
    state: 'radix',
    variant: 'square'
  }
})

type CheckboxProps = React.ComponentProps<typeof CheckboxPrimitive.Root> &
  Omit<VariantProps<typeof checkboxVariants>, 'state'>

function Checkbox({ className, variant, ...props }: CheckboxProps) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(checkboxVariants({ variant, className }))}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        <Check className="size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox, checkboxVariants }
